import { FC } from "react";
import { Paragraph, Subheading, TextLink } from "@contentful/f36-components";
import { ExternalLinkIcon } from "@contentful/f36-icons";
import tokens from "@contentful/f36-tokens";

const content: { [key: string]: JSX.Element } = {
    "3.0.0": (
        <>
            <Paragraph>
                We are launching exciting new{" "}
                <b style={{ color: tokens.purple500 }}>premium features</b> that will make your
                experience translating even smoother! As a first step, we're offering these features{" "}
                <strong>free to use</strong> for every Linguiny user:
            </Paragraph>
            <Subheading>💬 Formality</Subheading>
            <Paragraph>
                Customize the exact translation by specifying a more <strong>formal</strong> or{" "}
                <strong>informal</strong> tone for the translation.
            </Paragraph>
            <Paragraph>
                <b>Example:</b> <br />
                English: <i>What's your name?</i>
                <br />
                German (formal tone): <i>Wie ist Ihr Name?</i>
                <br />
                German (informal tone): <i>Wie ist dein Name?</i>
                <br />
            </Paragraph>
            <Paragraph>
                <TextLink
                    href="https://support.deepl.com/hc/articles/4406432463762-About-the-formality-feature"
                    target="_blank"
                    rel="noopener noreferrer"
                    icon={<ExternalLinkIcon />}
                    alignIcon="end">
                    More about formality
                </TextLink>
            </Paragraph>
            <Subheading>📖 Glossaries</Subheading>
            <Paragraph>
                Take full control of your translations with glossaries! Specify{" "}
                <strong>custom translations</strong> for certain words or phrases by adding them to
                your glossary.
            </Paragraph>
            <Paragraph>
                <b>Example:</b> <br />
                Specify the German word "Bank", which has a double meaning, to always mean "bank"
                and not "bench" (<i>Bank</i> → <i>bank</i>).
            </Paragraph>
            <Paragraph>
                German: <i>Die Bank ist schön.</i> <br />
                English (without glossary): <i>The bench is beautiful.</i> <br />
                English (with glossary): <i>The bank is beautiful.</i> <br />
            </Paragraph>
            <Paragraph>
                <TextLink
                    href="https://support.deepl.com/hc/articles/360021634540-About-the-glossary"
                    target="_blank"
                    rel="noopener noreferrer"
                    icon={<ExternalLinkIcon />}
                    alignIcon="end">
                    More about glossaries
                </TextLink>
            </Paragraph>
            <Paragraph>
                Any more questions? Contact{" "}
                <TextLink href="mailto:linguiny@becklyn.com">linguiny@becklyn.com</TextLink> for
                help.
            </Paragraph>
        </>
    ),
};

interface NewFeaturesContentProps {
    version: string;
}

export const NewFeaturesContent: FC<NewFeaturesContentProps> = ({ version }) => {
    return content[version] || null;
};
